import axios from "axios";
import buildUrl from "build-url-ts";
import {
  PageDetailResponse,
  PageSlidesResponse,
  StoryboardPagesResponse,
} from "src/types/experiences/storyboardSettings";

const BASE_URL = process.env.REACT_APP_CLEVERSTORY_API_URL;
const cleverstoryV1 = `${BASE_URL}/api/1.0/integrations/cleverstory`;
const pagesV2 = `${BASE_URL}/api/2.0/pages`;

export const storyboardPagesApi = {
  // Mirrors legacy fetchPagesForStoryBoardSaga (actions/cleverstory.ts:113)
  fetchPages: async (
    payload: { storyboardId: string; page?: number; limit?: number },
  ): Promise<StoryboardPagesResponse> => {
    const url = buildUrl(`${cleverstoryV1}/${payload.storyboardId}/pages`, {
      queryParams: {
        page: payload.page ?? 0,
        limit: payload.limit ?? 50,
      },
    });
    const response = await axios.get(url);
    return response.data;
  },

  fetchSlidesForPage: async (
    payload: { pageId: string; page?: number; limit?: number },
  ): Promise<PageSlidesResponse> => {
    const url = buildUrl(`${pagesV2}/${payload.pageId}/slides/all`, {
      queryParams: {
        page: payload.page ?? 0,
        limit: payload.limit ?? 50,
      },
    });
    const response = await axios.post(url);
    return response.data;
  },

  fetchPageDetail: async (pageId: string): Promise<PageDetailResponse> => {
    const url = buildUrl(`${pagesV2}/${pageId}`);
    const response = await axios.get(url);
    return response.data;
  },

  // Mirrors legacy searchPages saga (actions/pages.jsx:541) — lists a
  // storyboard's pages/sections via POST /api/2.0/pages/search.
  searchStoryboardPages: async (
    payload: { storyboardId: string; page?: number; limit?: number },
  ): Promise<StoryboardPagesResponse> => {
    const url = buildUrl(`${pagesV2}/search`, {
      queryParams: {
        page: payload.page ?? 0,
        limit: payload.limit ?? 50,
      },
    });
    const response = await axios.post(url, { storyboard: payload.storyboardId });
    return response.data;
  },
};
